import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';
import { errorCss } from '../baseStyles/index.styles';

const checkboxSize = 22;
export const labelLeftPadding = `calc(${checkboxSize}px + 9px)`;

export const checkboxError = css(errorCss, {
  margin: '0 0 20px 30px',
});

export const checkbox = css(typography.effra18, {
         display: 'inline-block',
         width: '100%',

         'input[type="checkbox"]': {
           opacity: 0,
           position: 'absolute',

           /* Hide the checkmark by default */
           '& + label:after': {
             content: 'none',
           },

           /* Unhide on the checked state */
           '&:checked + label::after': {
             content: '""',
           },

           /* Adding focus styles on the outer-box of the fake checkbox */
           '&:focus + label::before': {
             backgroundColor: colorsPalette.grey10,
           },

           '&:checked + label::before': {
             backgroundColor: colorsPalette.teal,
             border: `1px solid ${colorsPalette.teal}`,
             color: colorsPalette.white,
             content: '"\fea42"',
             font: 'normal normal normal 1rem/1 "regus-icon-font"',
             fontSize: 10,
             textAlign: 'center',
           },
         },

         /* Styles for Disabled */
         'input[disabled]': {
           '& + label': {
             color: colorsPalette.grey60,
             '&:hover': {
               cursor: 'default',
             },
             '&:before': {
               backgroundColor: colorsPalette.grey10,
             },
           },
         },

         '&:not(:last-child) label': {
           marginBottom: 22,
         },

         label: {
           position: 'relative',
           paddingLeft: labelLeftPadding,
           minHeight: checkboxSize,
           display: 'flex',
           alignItems: 'center',
           cursor: 'pointer',
           color: colorsPalette.black,
           lineHeight: 1.6,

           '&:hover': {
             '&:before': {
               backgroundColor: colorsPalette.grey10,
             },
           },

           '&:before, &:after': {
             position: 'absolute',
             content: '""',
           },

           /*  Outer box of the fake checkbox  */
           '&:before': {
             height: checkboxSize,
             width: checkboxSize,
             border: `1px solid ${colorsPalette.grey20}`,
             left: 0,
             top: 3,
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
           },
         },

         /*  Styles for error state  */
         '[data-error="true"]': {
           '&:before': {
             border: `1px solid ${colorsPalette.red120}`,
           },
         },
       });
